<template>
    <ModalContainer :visible="visible" :loading="loading" :is-small="true">
        <template v-slot:header>
            <button type="button" class="close" @click="$emit('close-separator-modal')"><i class="las la-times"></i></button>
            <h4 class="modal-title">{{ $t('components.separator.create') }}</h4>
        </template>
        <template v-slot:body>
            <div>
                <div class="form-group">
                    <label for="separator_name" class="control-label">{{$t('components.separator.name')}}*</label>
                    <input type="text" id="separator_name" name="separator_name" placeholder="e.g., Hatha" class="form-control" v-model="separator.name">
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <a class="btn btn-primary btn-lg btn-block"
               href=""
               @click.prevent.stop="createNewSeparator()">
                <i class="las la-check"></i>
                {{ $t('components.separator.create') }}
            </a>
        </template>
    </ModalContainer>
</template>

<script>
    import {createSeparator} from "../../api";
    import ModalContainer from "./ModalContainer";
    export default {
        name: "AddSeparatorModal",
        props: {
            visible: {
                type: Boolean,
                required: true
            }
        },
        data: () => {
            return {
                loading: false,
                separator: {
                    name: "",

                },
                errorMessage: ""
            }
        },
        components: {ModalContainer},
        methods: {
            async createNewSeparator() {
                this.loading = true;
                try {
                    await createSeparator(this.$route.params.showcase_id, this.separator.name);
                    this.loading = false;
                    this.$emit('success-add-separator-modal');

                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            onChangeVideo(separator) {
                this.separator = separator;
            }
        },
        watch: {
            visible(newVal) {
                if (newVal) {
                    this.separator.name = ''
                }
            }
        }
    };
</script>